export enum REDIRECTED_FROM {
  LOGIN = 'LoginPage',
  PASSWORD_CHANGE = 'PasswordChange',
}
